import {
  MdHomeMax,
  MdHouse,
  MdOutlineDashboard,
  MdOutlinePriceCheck,
  MdOutlineDeliveryDining,
  MdOutlineShoppingBag,
  MdBusiness,
} from "react-icons/md";
import { IoHomeOutline } from "react-icons/io5";
import { MdOutlineRateReview } from "react-icons/md";
import { CiDeliveryTruck } from "react-icons/ci";
import { FaBloggerB, FaBriefcase, FaRegUserCircle, FaUserShield } from "react-icons/fa";
import { IoCartOutline } from "react-icons/io5";
import { RiPriceTagLine, RiProductHuntLine } from "react-icons/ri";
import { AiOutlineBank } from "react-icons/ai";
import { CiLink } from "react-icons/ci";
import { FaCity } from "react-icons/fa";
import { MdOutlineCategory } from "react-icons/md";
import { LuTextQuote } from "react-icons/lu";
import { BiSolidCarousel } from "react-icons/bi";
import { IoIosPricetags } from "react-icons/io";
import { TbBrandSnowflake } from "react-icons/tb";
import { BsIntersect, BsLayoutTextWindow } from "react-icons/bs";
import { CgIfDesign } from "react-icons/cg";
import { FaFileContract } from "react-icons/fa6";
import {
  MdOutlineInventory,
  MdOutlineSettings,
  MdOutlineHome,
  MdOutlineAttachMoney,
  MdOutlineConstruction,
  MdOutlineArticle,
  MdOutlineDesignServices,
  MdMiscellaneousServices,
} from "react-icons/md";
import { GrProjects } from "react-icons/gr";
import Dashboard from "../Containers/dashboard/Dashboard/index.jsx";
import Products from "../Containers/shop/products/index.jsx";
import Categories from "../Containers/shop/categories/index.jsx";
import Users from "../Containers/general/user/index.jsx";
import Order from "../Containers/shop/orders/index.jsx";
import Invoice from "../Containers/shop/invoice/index.jsx";
import UserView from "../Containers/general/user-view/index.jsx";
import Review from "../Containers/shop/reviews/index.jsx";
import ProductDeliveryCharges from "../Containers/shop/product-delivery-charges/index.jsx";
import CategoryView from "../Containers/shop/category-view/index.jsx";
import ProductView from "../Containers/shop/product-view/index.jsx";
import ProductFormPage from "../Containers/shop/add-product/index.jsx";
import CategoriesProducts from "../Containers/shop/categories-products/index.jsx";
import BankAccount from "../Containers/general/bank-account-details/index.jsx";
import VerifyPayments from "../Containers/shop/verify-payments/index.jsx";
import UtmLinks from "../Containers/general/generate-social-links/index.jsx";
import Profile from "../Containers/profile/Profile/index.jsx";
import QuotationPage from "../Containers/shop/quotation/index.jsx";
import BannerManagement from "../Containers/shop/carousel-products/index.jsx";
import BrandManagement from "../Containers/shop/brands/index.jsx";
import TentiveCost from "../Containers/construction/tentative-cost/index.jsx";
import ConstructionCalculator from "../Containers/construction/construction-calculator/index.jsx";
import HomeScreen from "../Containers/general/home-screen/index.jsx";
import DataManagement from "../Components/HomeScreen/HomeScreenData.jsx";
import HouseDesing from "../Containers/house-design/house-design/index.jsx";
import BlogCategories from "../Containers/blogs/blog-categories-list/index.jsx";
import BlogLinkedCategoriesList from "../Containers/blogs/blog-linked-categories-list/index.jsx";
import BlogLinkedCategoryDetail from "../Containers/blogs/blog-linked-categories-detail/index.jsx";
import Blog from "../Containers/blogs/blog/index.jsx";
import BlogView from "../Containers/blogs/blog-view/index.jsx";
import HouseDesignDetails from "../Containers/house-design/house-design-details/index.jsx";
import FrontElevationDetails from "../Containers/house-design/front-elevation-details/index.jsx";
import BuyPlans from "../Containers/house-design/buy-plans/index.jsx";
import BuyThisPlanDetails from "../Containers/house-design/buy-this-plan-details/index.jsx";
import OurProjects from "../Containers/construction/our-projects/index.jsx";
import OurProjectsDetails from "../Containers/construction/our-projects-details/index.jsx";
import OurProjectCategories from "../Containers/construction/our-project-categories/index.jsx";
import OurProjectCommercialDesign from "../Containers/construction/our-project-commercial-design/index.jsx";
import OurProjectCommercialDesignDetails from "../Containers/construction/our-project-commercial-design-details/index.jsx";
import OurProjectCommercialDesignCategories from "../Containers/construction/our-project-commercial-design-categories/index.jsx";
import OurProjectCorporateDesign from "../Containers/construction/our-project-corporate-design/index.jsx";
import OurProjectCorporateDesignDetails from "../Containers/construction/our-project-corporate-design-details/index.jsx";
import OurProjectCorporateDesignCategories from "../Containers/construction/our-project-corporate-design-categories/index.jsx";
import InteriorDesignCategory from "../Containers/interior-designs/interior-design-categories/index.jsx";
import InteriorDesign from "../Containers/interior-designs/interior-design/index.jsx";
import InteriorDesignDetails from "../Containers/interior-designs/interior-design-details/index.jsx";
import OutStationZonePage from "../Containers/shop/out-station-zone/index.jsx";
import OutStationBaseRatesPage from "../Containers/shop/out-station-base-rate/index.jsx";
import Cities from "../Containers/shop/cities/index.jsx";
import InStationZonePage from "../Containers/shop/in-station-zone/index.jsx";
import InStationBaseRatePage from "../Containers/shop/in-station-base-rate/index.jsx";
import BudgetPricing from "../Containers/pricing/budget-pricing/index.jsx";
import PremiumPricing from "../Containers/pricing/premium-pricing/index.jsx";
import Services from "../Containers/construction/services/index.jsx";
import ServiceDetails from "../Containers/construction/service-details/index.jsx";
import ServiceCategories from "../Containers/construction/service-categories/index.jsx";
import Contracts from "../Containers/Contracts/contracts/index.jsx";
import ContractsDetails from "../Containers/Contracts/contracts-details/index.jsx";
import UserContracts from "../Containers/Contracts/user-contracts/index.jsx";
import DesignContracts from "../Containers/DesignContracts/design-contracts/index.jsx";
import DesignContractsDetails from "../Containers/DesignContracts/design-contracts-details/index.jsx";
import UserDesignContracts from "../Containers/DesignContracts/user-design-contracts/index.jsx";
import PurchasedHouseDesigns from "../Containers/house-design/purchased-house-designs/index.jsx";
import PurchasedHouseDesignDetail from "../Containers/house-design/purchased-house-design-detail/index.jsx";
import ContractCategories from "../Containers/Contracts/contract-categories/index.jsx";
import ManageRoles from "../Containers/roles-permissions/manage-roles/index.jsx";
import ManagePermissions from "../Containers/roles-permissions/manage-permissions/index.jsx";
import RoleForm from "../Containers/roles-permissions/role-form/index.jsx";
import ManageAdminUsers from "../Containers/roles-permissions/manage-admin-users/index.jsx";
import AdminUserForm from "../Containers/roles-permissions/admin-user-form/index.jsx";
import Unauthorized from "../Containers/general/unauthorized/index.jsx";
import CommercialArchitectureDesign from "../Containers/commercial-design/architecture-design/index.jsx";
import CommercialArchitectureDesignDetails from "../Containers/commercial-design/architecture-design-details/index.jsx";
import CorporateArchitectureDesign from "../Containers/corporate-design/architecture-design/index.jsx";
import CorporateArchitectureDesignDetails from "../Containers/corporate-design/architecture-design-details/index.jsx";
import CommercialInteriorDesign from "../Containers/commercial-design/interior-design/index.jsx";
import CommercialInteriorDesignCategory from "../Containers/commercial-design/interior-design-categories/index.jsx";
import CommercialInteriorDesignDetails from "../Containers/commercial-design/interior-design-details/index.jsx";
import CorporateInteriorDesign from "../Containers/corporate-design/interior-design/index.jsx";
import CorporateInteriorDesignCategory from "../Containers/corporate-design/interior-design-categories/index.jsx";
import CorporateInteriorDesignDetails from "../Containers/corporate-design/interior-design-details/index.jsx";
import SeoManagement from "../Containers/seo-management/dynamic-seo/index.jsx";
import StaticPages from "../Containers/seo-management/static-seo/index.jsx";
import Translations from "../Containers/translations/index.jsx";
import { HiOutlineTranslate } from "react-icons/hi";

const routePermission = (resource, actions = ["read"]) => ({
  resource,
  actions,
});

const routes = [
  {
    path: "/profile",
    element: Profile,
    visible: false,
  },
  {
    path: "/unauthorized",
    element: Unauthorized,
    visible: false,
  },
  {
    path: "/dashboard",
    element: Dashboard,
    label: "Dashboard",
    icon: <MdOutlineDashboard size={24} />,
    permission: routePermission("Dashboard"),
  },
  {
    label: "Seo Management",
    icon: <MdOutlineArticle size={24} />,
    isGroup: true,
    children: [
      {
        path: "/seo-management",
        element: SeoManagement,
        label: "Dynamic Page",
        icon: <MdOutlineArticle size={24} />,
        permission: routePermission("SEO Management"),
      },
      {
        path: "/static-pages",
        element: StaticPages,
        label: "Static Pages",
        icon: <BsLayoutTextWindow size={24} />,
        permission: routePermission("Static Pages"),
      },
      {
        path: "/translations",
        element: Translations,
        label: "Translations",
        icon: <HiOutlineTranslate size={24} />,
        permission: routePermission("Translations"),
        visible: false,
      },
    ],
  },
  {
    label: "General",
    icon: <MdOutlineSettings size={30} />,
    isGroup: true,
    children: [
      {
        path: "/users",
        element: Users,
        label: "Users",
        icon: <FaRegUserCircle size={24} />,
        permission: routePermission("Users"),
      },
      {
        path: "/bank-account-details",
        element: BankAccount,
        label: "Bank Account Details",
        icon: <AiOutlineBank size={24} />,
        permission: routePermission("Bank Account Details"),
      },
      // {
      //   path: "/social-links",
      //   element: UtmLinks,
      //   label: "Generate Social Links",
      //   icon: <CiLink size={24} />,
      //   permission: routePermission("Generate Social Links"),
      // },
      {
        path: "/home-screen",
        element: HomeScreen,
        label: "HomeScreen Management",
        icon: <MdHomeMax size={24} />,
        permission: [
          routePermission("Home Screen House Design"),
          routePermission("Home Screen Consturction Our Projects"),
          routePermission("Home Screen Consturction Blogs"),
          routePermission("Home Screen Interior Design"),
          routePermission("Home Screen Consturction Shop"),
          routePermission("Home Screen Consturction Calculaotr"),
        ],
      },
    ],
  },

  {
    label: "Shop",
    icon: <MdOutlineInventory size={30} />,
    isGroup: true,
    children: [
      {
        label: "Delivery Management",
        icon: <MdOutlineDeliveryDining size={24} />,
        isGroup: true,
        children: [
          {
            path: "/out-station-zones",
            element: OutStationZonePage,
            label: "Out Station Zones",
            icon: <CiDeliveryTruck size={24} />,
            permission: routePermission("Out Station Zones"),
          },
          {
            path: "/out-station-base-rate",
            element: OutStationBaseRatesPage,
            label: "Out Station Base Rate",
            icon: <MdOutlineRateReview size={24} />,
            permission: routePermission("Out Station Base Rate"),
          },
          {
            path: "/cities",
            element: Cities,
            label: "Add Cities",
            icon: <FaCity size={24} />,
            permission: routePermission("Cities"),
          },
          {
            path: "/in-station-zones",
            element: InStationZonePage,
            label: "In Station Zones",
            icon: <CiDeliveryTruck size={24} />,
            permission: routePermission("In Station Zones"),
          },
          {
            path: "/in-station-base-rate",
            element: InStationBaseRatePage,
            label: "In Station Base Rate",
            icon: <MdOutlineRateReview size={24} />,
            permission: routePermission("In Station Base Rate"),
          },
        ],
      },
      {
        path: "/category",
        element: Categories,
        label: "Categories",
        icon: <MdOutlineCategory size={24} />,
        permission: routePermission("Shop Categories"),
      },
      {
        path: "/products",
        element: Products,
        label: "Products",
        icon: <RiProductHuntLine size={24} />,
        permission: routePermission("Products"),
      },
      {
        path: "/quotation",
        element: QuotationPage,
        label: "Generate Quotation",
        icon: <LuTextQuote size={24} />,
        permission: routePermission("Generate Quotation"),
      },
      {
        path: "/orders",
        element: Order,
        label: "Orders",
        icon: <IoCartOutline size={24} />,
        permission: routePermission("Orders"),
      },
      {
        path: "/reviews",
        element: Review,
        label: "Manage Reviews",
        icon: <MdOutlineRateReview size={24} />,
        permission: routePermission("Reviews"),
      },
      // {
      //   path: "/product-delivery-charges",
      //   element: ProductDeliveryCharges,
      //   label: "Product Delivery Charges",
      //   icon: <CiDeliveryTruck size={24} />,
      //   permission: routePermission("Product Delivery Charges"),
      // },
      {
        path: "/add-brands",
        element: BrandManagement,
        label: "Brands Management",
        icon: <TbBrandSnowflake size={24} />,
        permission: routePermission("Brands Management"),
      },
      // {
      //   path: "/manage-carousel",
      //   element: BannerManagement,
      //   label: "Carousel Items",
      //   icon: <BiSolidCarousel size={24} />,
      //   permission: routePermission("Manage Banners"),
      // },
    ],
  },
  {
    label: "Architecture Design",
    icon: <CgIfDesign size={30} />,
    isGroup: true,
    children: [
      {
        label: "House Design",
        icon: <MdOutlineHome size={24} />,
        isGroup: true,
        children: [
          {
            path: "/house-design",
            element: HouseDesing,
            label: "House Design",
            icon: <MdHouse size={24} />,
            permission: routePermission("House Design"),
          },
          {
            path: "/buy-plans",
            element: BuyPlans,
            label: "Standard Plan Pricing",
            icon: <MdOutlinePriceCheck size={24} />,
            permission: routePermission("Standard Plan Pricing"),
          },
          {
            path: "/purchased-house-designs",
            element: PurchasedHouseDesigns,
            label: "Purchased House Designs",
            icon: <MdOutlineShoppingBag size={24} />,
            permission: routePermission("Purchased house designs"),
          },
        ],
      },
      {
        label: "Commercial Design",
        icon: <MdBusiness size={24} />,
        isGroup: true,
        children: [
          {
            path: "/commercial-architecture-design",
            element: CommercialArchitectureDesign,
            label: "Commercial Architecture Design",
            icon: <MdBusiness size={24} />,
            permission: routePermission("Commercial Architecture Design"),
          },
        ],
      },
      {
        label: "Corporate Design",
        icon: <FaBriefcase size={24} />,
        isGroup: true,
        children: [
          {
            path: "/corporate-architecture-design",
            element: CorporateArchitectureDesign,
            label: "Corporate Architecture Design",
            icon: <FaBriefcase size={24} />,
            permission: routePermission("Corporate Architecture Design"),
          },
        ],
      },
    ],
  },

  {
    label: "Interior Design",
    icon: <BsLayoutTextWindow size={30} />,
    isGroup: true,
    children: [
      {
        label: "House Design",
        icon: <MdOutlineHome size={24} />,
        isGroup: true,
        children: [
          {
            path: "/interior-design-categories",
            element: InteriorDesignCategory,
            label: "Interior Design Categories",
            icon: <BsIntersect size={24} />,
            permission: routePermission("Interior Design Categories"),
          },
          {
            path: "/interior-design",
            element: InteriorDesign,
            label: "Interior Design",
            icon: <CgIfDesign size={24} />,
            permission: routePermission("Interior Design"),
          },
        ],
      },
      {
        label: "Commercial Design",
        icon: <MdBusiness size={24} />,
        isGroup: true,
        children: [
          {
            path: "/commercial-interior-design-categories",
            element: CommercialInteriorDesignCategory,
            label: "Commercial Interior Design Categories",
            icon: <BsIntersect size={24} />,
            permission: routePermission("Commercial Interior Design Categories"),
          },
          {
            path: "/commercial-interior-design",
            element: CommercialInteriorDesign,
            label: "Commercial Interior Design",
            icon: <CgIfDesign size={24} />,
            permission: routePermission("Commercial Interior Design"),
          },
        ],
      },
      {
        label: "Corporate Design",
        icon: <FaBriefcase size={24} />,
        isGroup: true,
        children: [
          {
            path: "/corporate-interior-design-categories",
            element: CorporateInteriorDesignCategory,
            label: "Corporate Interior Design Categories",
            icon: <BsIntersect size={24} />,
            permission: routePermission("Corporate Interior Design Categories"),
          },
          {
            path: "/corporate-interior-design",
            element: CorporateInteriorDesign,
            label: "Corporate Interior Design",
            icon: <CgIfDesign size={24} />,
            permission: routePermission("Corporate Interior Design"),
          },
        ],
      },
    ],
  },

  {
    label: "Pricing",
    icon: <MdOutlineAttachMoney size={30} />,
    isGroup: true,
    children: [
      {
        path: "/budget-pricing",
        element: BudgetPricing,
        label: "Budget Pricing",
        icon: <IoIosPricetags size={24} />,
        permission: routePermission("Budget Pricing"),
      },
      {
        path: "/premium-pricing",
        element: PremiumPricing,
        label: "Premium Pricing",
        icon: <IoIosPricetags size={24} />,
        permission: routePermission("Premium Pricing"),
      },
    ],
  },
  {
    label: "Construction",
    icon: <MdOutlineConstruction size={30} />,
    isGroup: true,
    children: [
      {
        path: "/construction-calculator",
        element: ConstructionCalculator,
        label: "Calculators List",
        icon: <MdOutlineConstruction size={24} />,
        permission: routePermission("Construction Calculators"),
      },
      {
        path: "/tentative-cost",
        element: TentiveCost,
        label: "Tentative Cost",
        icon: <RiPriceTagLine size={24} />,
        permission: routePermission("Tentative Cost"),
      },
      {
        label: "Services",
        icon: <MdMiscellaneousServices size={24} />,
        isGroup: true,
        children: [
          {
            path: "/services",
            element: Services,
            label: "Services",
            icon: <MdMiscellaneousServices size={24} />,
            permission: routePermission("Services"),
          },
          {
            path: "/service-categories",
            element: ServiceCategories,
            label: "Service Categories",
            icon: <MdMiscellaneousServices size={24} />,
            permission: routePermission("Service Categories"),
          },
        ],
      },
      // {
      //   label: "Construction Calculator",
      //   icon: <MdOutlineConstruction size={24} />,
      //   isGroup: true,
      //   children: [
      //     {
      //       path: "/tentative-cost",
      //       element: TentiveCost,
      //       label: "Tentative Cost",
      //       icon: <RiPriceTagLine size={24} />,
      //     },
      //   ],
      // },
      {
        label: "Our Projects",
        icon: <GrProjects size={24} />,
        isGroup: true,
        children: [
          {
            path: "/our-project-categories",
            element: OurProjectCategories,
            label: "Our Projects House Design",
            icon: <GrProjects size={24} />,
            permission: routePermission("Our Project Categories"),
          },
          {
            path: "/our-project-commercial-design-categories",
            element: OurProjectCommercialDesignCategories,
            label: "Our Project Commercial Design",
            icon: <GrProjects size={24} />,
            permission: routePermission("Our Project Commercial Design Categories"),
          },
          {
            path: "/our-project-corporate-design-categories",
            element: OurProjectCorporateDesignCategories,
            label: "Our Project Corporate Design",
            icon: <GrProjects size={24} />,
            permission: routePermission("Our Project Corporate Design Categories"),
          },
        ],
      },
    ],
  },
  {
    label: "Blogs",
    icon: <MdOutlineArticle size={30} />,
    isGroup: true,
    children: [
      {
        path: "/blog-categories",
        element: BlogCategories,
        label: "Blog Categories",
        icon: <MdOutlineRateReview size={24} />,
        permission: routePermission("Blog Categories"),
      },
      {
        path: "/blogs",
        element: Blog,
        label: "Blogs",
        icon: <FaBloggerB size={24} />,
        permission: routePermission("Blogs"),
      },
    ],
  },

  {
    label: "Contracts",
    icon: <FaFileContract size={30} />,
    isGroup: true,
    children: [
      {
        label: "Construction Contracts",
        icon: <FaFileContract size={24} />,
        isGroup: true,
        children: [
          {
            path: "/contract-categories",
            element: ContractCategories,
            label: "Contract Categories",
            permission: routePermission("Contract Categories"),
          },
          {
            path: "/contracts",
            element: Contracts,
            label: "Contracts",
            permission: routePermission("Contract"),
          },
          {
            path: "/contracts/user-contracts/:id",
            element: UserContracts,
            label: "User Contracts",
            visible: false,
            permission: routePermission("Contract"),
          },
          {
            path: "/contracts/view/:id",
            element: ContractsDetails,
            label: "Contracts Details",
            visible: false,
            permission: routePermission("Contract"),
          },
        ],
      },
      {
        label: "Design Contracts",
        icon: <FaFileContract size={24} />,
        isGroup: true,
        children: [
          {
            path: "/design-contracts",
            element: DesignContracts,
            label: "Design Contracts",
            permission: routePermission("Design Contract"),
          },
          {
            path: "/design-contracts/user-contracts/:id",
            element: UserDesignContracts,
            label: "User Design Contracts",
            visible: false,
            permission: routePermission("Design Contract"),
          },
          {
            path: "/design-contracts/view/:id",
            element: DesignContractsDetails,
            label: "Design Contracts Details",
            visible: false,
            permission: routePermission("Design Contract"),
          },
        ],
      },
    ],
  },
  {
    path: "/category/view",
    element: CategoryView,
    label: "Category",
    icon: <IoHomeOutline size={30} />,
    visible: false,
    permission: routePermission("Shop Categories"),
  },
  {
    path: "/category/view/products",
    element: CategoriesProducts,
    label: "Category",
    icon: <IoHomeOutline size={30} />,
    visible: false,
    permission: routePermission("Shop Categories"),
  },
  {
    path: "/products/view",
    element: ProductView,
    label: "Products",
    visible: false,
    permission: routePermission("Products"),
  },
  {
    path: "/products/add",
    element: ProductFormPage,
    label: "Add Product",
    visible: false,
    permission: routePermission("Products"),
  },
  {
    path: "/products/edit",
    element: ProductFormPage,
    label: "Edit Product",
    visible: false,
    permission: routePermission("Products"),
  },
  {
    path: "/users/view",
    element: UserView,
    label: "Users",
    icon: <FaRegUserCircle size={30} />,
    visible: false,
    permission: routePermission("Users"),
  },
  {
    path: "/orders/invoice",
    element: Invoice,
    label: "Invoice",
    icon: <CiDeliveryTruck size={30} />,
    visible: false,
    permission: routePermission("Orders"),
  },
  {
    path: "/orders/verify-payment",
    element: VerifyPayments,
    label: "Invoice",
    icon: <CiDeliveryTruck size={30} />,
    visible: false,
    permission: routePermission("Orders"),
  },
  {
    path: "/house-design/:id",
    element: HouseDesignDetails,
    visible: false,
    permission: routePermission("House Design"),
  },
  {
    path: "/commercial-architecture-design/:id",
    element: CommercialArchitectureDesignDetails,
    visible: false,
    permission: routePermission("Commercial Architecture Design"),
  },
  {
    path: "/corporate-architecture-design/:id",
    element: CorporateArchitectureDesignDetails,
    visible: false,
    permission: routePermission("Corporate Architecture Design"),
  },
  {
    path: "/purchased-house-designs/view/:purchaseId",
    element: PurchasedHouseDesignDetail,
    visible: false,
    permission: routePermission("Purchased house designs"),
  },
  {
    path: "/services/:id",
    element: ServiceDetails,
    visible: false,
    permission: routePermission("Services"),
  },
  // {
  //   path: "/front-elevation",
  //   element: FrontElevation,
  //   label: "Front Elevation",
  //   icon: <HiOutlineBuildingStorefront size={30} />,
  // },
  {
    path: "/front-elevation/:id",
    element: FrontElevationDetails,
    visible: false,
    permission: routePermission("House Design"),
  },
  {
    path: "/data-management",
    element: DataManagement,
    visible: false,
    permission: [
      routePermission("Home Screen House Design"),
      routePermission("Home Screen Consturction Our Projects"),
      routePermission("Home Screen Consturction Blogs"),
      routePermission("Home Screen Interior Design"),
      routePermission("Home Screen Consturction Shop"),
      routePermission("Home Screen Consturction Calculaotr"),
    ],
  },
  {
    path: "/blog-category/view/",
    element: BlogLinkedCategoriesList,
    visible: false,
    permission: routePermission("Blog Categories"),
  },
  {
    path: "/blog-categories/view/details",
    element: BlogLinkedCategoryDetail,
    visible: false,
    permission: routePermission("Blog Categories"),
  },
  {
    path: "/blog/view/:id",
    element: BlogView,
    visible: false,
    permission: routePermission("Blogs"),
  },
  {
    path: "/blogs/edit/:id",
    element: Blog,
    visible: false,
    permission: routePermission("Blogs", ["update"]),
  },
  {
    path: "/buy-this-plan/details",
    element: BuyThisPlanDetails,
    visible: false,
    permission: routePermission("Standard Plan Pricing"),
  },
  {
    path: "/our-projects/:id",
    element: OurProjects,
    visible: false,
    permission: routePermission("Manage Project"),
  },
  {
    path: "/our-projects/view/:id",
    element: OurProjectsDetails,
    visible: false,
    permission: routePermission("Manage Project"),
  },
  {
    path: "/our-project-commercial-design/:id",
    element: OurProjectCommercialDesign,
    visible: false,
    permission: routePermission("Manage Commercial Design Project"),
  },
  {
    path: "/our-project-commercial-design/view/:id",
    element: OurProjectCommercialDesignDetails,
    visible: false,
    permission: routePermission("Manage Commercial Design Project"),
  },
  {
    path: "/our-project-corporate-design/:id",
    element: OurProjectCorporateDesign,
    visible: false,
    permission: routePermission("Manage Corporate Design Project"),
  },
  {
    path: "/our-project-corporate-design/view/:id",
    element: OurProjectCorporateDesignDetails,
    visible: false,
    permission: routePermission("Manage Corporate Design Project"),
  },
  {
    path: "/interior-design/:id",
    element: InteriorDesignDetails,
    visible: false,
    permission: routePermission("Interior Design"),
  },
  {
    path: "/commercial-interior-design/:id",
    element: CommercialInteriorDesignDetails,
    visible: false,
    permission: routePermission("Commercial Interior Design"),
  },
  {
    path: "/corporate-interior-design/:id",
    element: CorporateInteriorDesignDetails,
    visible: false,
    permission: routePermission("Corporate Interior Design"),
  },
  {
    label: "Roles and Permissions",
    icon: <FaUserShield size={30} />,
    isGroup: true,
    requiresSuperAdmin: true,
    children: [
      {
        path: "/roles",
        element: ManageRoles,
        label: "Manage Roles",
        icon: <FaUserShield size={24} />,
        permission: routePermission("Role"),
      },
      {
        path: "/permissions",
        element: ManagePermissions,
        label: "Manage Permissions",
        icon: <MdOutlineSettings size={24} />,
        permission: routePermission("Permission"),
      },
      {
        path: "/admin-users",
        element: ManageAdminUsers,
        label: "Manage Users",
        icon: <FaRegUserCircle size={24} />,
        permission: routePermission("Users"),
      },
      {
        path: "/roles/create",
        element: RoleForm,
        visible: false,
        permission: routePermission("Role", ["create"]),
      },
      {
        path: "/roles/edit/:id",
        element: RoleForm,
        visible: false,
        permission: routePermission("Role", ["update"]),
      },
      {
        path: "/roles/view/:id",
        element: RoleForm,
        visible: false,
        permission: routePermission("Role"),
      },
      {
        path: "/admin-users/create",
        element: AdminUserForm,
        visible: false,
        permission: routePermission("Users", ["create"]),
      },
      {
        path: "/admin-users/edit/:id",
        element: AdminUserForm,
        visible: false,
        permission: routePermission("Users", ["update"]),
      },
      {
        path: "/admin-users/view/:id",
        element: AdminUserForm,
        visible: false,
        permission: routePermission("Users"),
      },
    ],
  },
];

export default routes;
